import { useEffect, useState } from 'react';
import api from '@/lib/api';
import { ExternalLink } from 'lucide-react';

export default function NewsRail({ compact = false }) {
  const [articles, setArticles] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let alive = true;
    const load = async () => {
      try {
        const r = await api.get(`/news?limit=${compact ? 8 : 15}`);
        if (alive) { setArticles(r.data.articles); setLoading(false); }
      } catch (_e) { if (alive) setLoading(false); }
    };
    load();
    const iv = setInterval(load, 300000);
    return () => { alive = false; clearInterval(iv); };
  }, [compact]);

  const timeAgo = (ts) => {
    if (!ts) return '';
    const s = Math.floor(Date.now() / 1000) - ts;
    if (s < 60) return `${s}s ago`;
    if (s < 3600) return `${Math.floor(s / 60)}m ago`;
    if (s < 86400) return `${Math.floor(s / 3600)}h ago`;
    return `${Math.floor(s / 86400)}d ago`;
  };

  return (
    <div className="bg-[#181A20]" data-testid="news-rail">
      <div className="px-3 py-2 border-b border-[#2B3139] text-[10px] uppercase tracking-wider text-[#EAECEF] font-semibold flex items-center justify-between">
        <span>Market News</span>
        <span className="text-[#5E6673] normal-case">Cointelegraph</span>
      </div>
      <div className="max-h-[540px] overflow-y-auto">
        {loading ? (
          <div className="p-4 text-[#848E9C] text-xs">Loading…</div>
        ) : articles.length === 0 ? (
          <div className="p-4 text-[#848E9C] text-xs">No news available.</div>
        ) : articles.map((a) => (
          <a key={a.id} href={a.url} target="_blank" rel="noreferrer"
            className="block px-3 py-2.5 border-b border-[#2B3139]/60 hover:bg-[#2B3139] transition-colors"
            data-testid={`news-item-${a.id}`}>
            <div className="flex gap-2">
              {a.image && (
                <img src={a.image} alt="" className="w-12 h-12 object-cover flex-shrink-0" onError={(e) => e.target.style.display = 'none'} />
              )}
              <div className="flex-1 min-w-0">
                <div className="text-white text-xs font-medium leading-snug line-clamp-3">{a.title}</div>
                <div className="text-[10px] text-[#5E6673] mt-1 flex items-center gap-1">
                  <span>{timeAgo(a.published_at)}</span>
                  <ExternalLink className="w-2.5 h-2.5 opacity-60" />
                </div>
              </div>
            </div>
          </a>
        ))}
      </div>
    </div>
  );
}
